/* eslint-disable max-len */
import React from 'react';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {paths} from '../../../common/dictionaries/urls';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {Actions} from '../../../common/actions';
import {connect} from 'react-redux';
import {Button, Card} from 'semantic-ui-react';
import mapKeys from 'lodash/mapKeys';
import orderBy from 'lodash/orderBy';
import './vehiclesMaintenance.scss';
import VehiclesHistoryColor from '../vehiclesHistoryColor';
import VehiclesPriceColor from '../vehiclesPriceColor';
import VehiclesMaintenanceTable from './Table';
import {getColumns} from './tableColumns';
import {handleExcelColorPrices} from '../../utils';

class VehiclesMaintenance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      'value': '',
      'filtered': [],
      'modalWasOpen': false,
      'modalPriceWasOpen': false,
      'selectedVehicle': {},
      'vehiclesLength': 0,
      'columns': getColumns({
        'getUniqueValuesByField': this.getUniqueValuesByField.bind(this),
        'vehicles': this.props.vehicles,
        'onChangeSelectFamily': this.onChangeSelectFamily.bind(this),
        'renderOption': this.renderOption.bind(this),
        'onChangeSelectState': this.onChangeSelectState.bind(this),
        'renderOptionState': this.renderOptionState.bind(this),
        'handleClickColors': this.handleClickColors.bind(this),
        'handleClickPriceColors': this.handleClickPriceColors.bind(this),
        'loading': this.props.loading,
      }),
    };
    this.closeVehiclesColorsModal = this.closeVehiclesColorsModal.bind(this);
    this.closeVehiclesPriceColorsModal = this.closeVehiclesPriceColorsModal.bind(this);
  }

  handleClickColors = (row) => {
    this.setState({
      'modalWasOpen': true,
      'selectedVehicle': row,
    });
  }

  handleClickPriceColors = (row) => {
    this.setState({
      'modalPriceWasOpen': true,
      'selectedVehicle': row,
    });
  }

  closeVehiclesColorsModal() {
    this.setState({
      'modalWasOpen': false,
      'selectedVehicle': {},
    });
  }

  closeVehiclesPriceColorsModal() {
    this.setState({
      'modalPriceWasOpen': false,
      'selectedVehicle': {},
    });
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.VehiclesMaintenance, scopes.See)) {
      this.props.push(paths.AccessDenied);
    }

    this.props.fetchVehiclesMaintenance();
    this.props.fetchVehiclesModel();
    this.props.fetchAllActivePrices();
  }

  componentDidUpdate() {
    if (this.props.vehicles.length !== this.state.vehiclesLength) {
      this.setState({
        'columns': getColumns({
          'getUniqueValuesByField': this.getUniqueValuesByField.bind(this),
          'vehicles': this.props.vehicles,
          'onChangeSelectFamily': this.onChangeSelectFamily.bind(this),
          'renderOption': this.renderOption.bind(this),
          'onChangeSelectState': this.onChangeSelectState.bind(this),
          'renderOptionState': this.renderOptionState.bind(this),
          'handleClickColors': this.handleClickColors.bind(this),
          'handleClickPriceColors': this.handleClickPriceColors.bind(this),
          'loading': this.props.loading,
        }),
        'vehiclesLength': this.props.vehicles.length,
      });
    }
  }

  renderOption(vehicle) {
    const name = vehicle && vehicle.name && vehicle.name.toUpperCase();
    return (
      <option key={vehicle.name} value={name}>
        {name}
      </option>
    );
  }

  renderOptionState() {
    return (
      <React.Fragment>
        <option value="A">ACTIVO</option>
        <option value="I">INACTIVO</option>
      </React.Fragment>
    );
  }

  getUniqueValuesByField = (currentList, fieldName = 'id') => {
    if (currentList === null) {
      return;
    }
    if (typeof currentList !== 'object') {
      return;
    }
    if (currentList && currentList.length === 0) {
      return;
    }
    return [...new Map(currentList.map((item) => [item[fieldName], item])).values()];
  }

  onChangeSelectFamily = (event, row) => {
    const {vehiclesSortName} = this.props;
    const value = event.target.value;
    const status = row.original.status;
    const sfx = row.original.sfx;
    const masterCode = row.original.masterCode;
    const data = {
      sfx,
      'master_code': masterCode,
      status,
      'commercialName': value,
      'familyId': (vehiclesSortName[value] && vehiclesSortName[value].id) || '',
    };
    this.props.updateVehiclesMaintenance({'data': data});
  };

  onChangeSelectState = (event, row) => {
    const value = event.target.value;
    const sfx = row.original.sfx;
    const masterCode = row.original.masterCode;
    const commercialName = row.original.commercialName;
    const familyId = row.original.familyId;
    const data = {
      sfx,
      'master_code': masterCode,
      'status': value,
      'commercialName': commercialName,
      'familyId': familyId,
    };
    this.props.updateVehiclesMaintenance({'data': data});
  };


  onFilteredChangeCustom = (value, accessor) => {
    const filtered = this.state.filtered;
    let insertNewFilter = 1;

    if (filtered.length) {
      filtered.forEach((filter, i) => {
        if (filter.id === accessor) {
          if (value === '' || !value.length) {
            filtered.splice(i, 1);
          } else {
            filter.value = value;
          }

          insertNewFilter = 0;
        }
      });
    }

    if (insertNewFilter) {
      filtered.push({'id': accessor, 'value': value});
    }

    this.setState({'filtered': filtered});
  };

  render() {
    const {columns, modalWasOpen, selectedVehicle, modalPriceWasOpen} = this.state;
    const {loadingVehiclesMaintenance, loadingVehicles} = this.props;
    if (loadingVehiclesMaintenance || loadingVehicles) {
      return <h1>Cargando...</h1>;
    }
    return (
      <div>
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2>Mantenimiento Vehículos</h2>
              <div className="title-bar-actions">
                <Button
                  primary
                  color='red'
                  disabled={!this.props.allvehiclesPrices || this.props.loadingAllvehiclesPrices}
                  onClick={() => handleExcelColorPrices(this.props.allvehiclesPrices)}
                >
                  EXPORTAR
                </Button>
                <Button primary color='red' onClick={() => this.props.navigateTo(paths.VehiclesPriceColorLoad)}>
                  IMPORTAR
                </Button>
              </div>
            </div>
          </div>
        </Card>
        <Card raised fluid>
          {modalWasOpen && <VehiclesHistoryColor modalWasOpen={modalWasOpen} selectedVehicle={selectedVehicle}
            onCloseModal={this.closeVehiclesColorsModal} />
          }
          {
            selectedVehicle?.values && (
              <VehiclesPriceColor
                modalIsOpen={modalPriceWasOpen}
                selectedVehicle={selectedVehicle}
                handleCloseModal={this.closeVehiclesPriceColorsModal.bind(this)}
              />
            )
          }
          <VehiclesMaintenanceTable tableData={this.props.vehiclesMaintenance} columnsTable={columns}/>
        </Card>
      </div>
    );
  }
}

const {
  fetchAllActivePrices,
  fetchVehiclesMaintenance,
  fetchVehiclesModel,
  updateVehiclesMaintenance,
  withRouter,
  navigateTo,
} = Actions;

const mapStateToProps = (state, ownProps) => {
  const {vehiclesMaintenance} = state.vehiclesMaintenance;
  const {vehicles} = state.vehiclesModels;
  return {
    'permissions': state.session.permissions,
    'push': ownProps.history.push,
    vehiclesMaintenance,
    'loadingVehiclesMaintenance': state.vehiclesMaintenance.loading,
    'vehicles': orderBy(mapKeys(vehicles, 'idx'), 'idx'),
    'vehiclesSortName': mapKeys(vehicles, 'name'),
    'loadingVehicles': state.vehiclesModels.loading,
    'allvehiclesPrices': state.vehiclePriceColor.allvehiclesPrices.data,
    'loadingAllvehiclesPrices': state.vehiclePriceColor.allvehiclesPrices.loading,
  };
};

export default withRouter(connect(
  mapStateToProps,
  {
    fetchAllActivePrices,
    fetchVehiclesMaintenance,
    fetchVehiclesModel,
    updateVehiclesMaintenance,
    navigateTo,
  }
)(VehiclesMaintenance));
